/**
 * DBコンスト
 */

/*
 * BookingType
 */
// 予約種別
export const BOOKING_TYPE_ID_TAKEOUT: number = 1;
export const BOOKING_TYPE_ID_POMPOUT1: number = 2;
export const BOOKING_TYPE_ID_POMPOUT2: number = 3;

/*
 * Solvents
 */
/** 溶媒ID（ジエチルエーテル 特級） */
export const SOLVENT_ID_DIETHYLETHER: number = 17;
/** 溶媒ID（ペンタン） */
export const SOLVENT_ID_PENTANE: number = 19;
// 単位
export const UNIT_ID_KG: string = `1`;
export const UNIT_ID_L: string = `2`;
